module.exports = __webpack_public_path__ + "brand-icons.a1d7a3d5d78b9164fff3.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/brand-icons/brand-icons.ttf?v=0.3.2
// module id = ../../../../../src/fonts/brand-icons/brand-icons.ttf?v=0.3.2
// module chunks = 5